import IndexedDB from "#/data-layer/IndexedDB";
import {
  DB_NAME,
  DB_VERSION,
  DEFINITIONS,
  LOOKUP_TABLES,
} from "#/def/data-layer";

/**
 * Takes dynamic definitions from #/def/data-layer and
 * pushes unique ones to the “osDefinitions” list,
 * which is then used to initialize the IndexedDB instance.
 *
 * This allows us to manage object stores based on the provided
 * definitions without hardcoding them in the IndexedDB class,
 * and ensures that we only create stores for definitions
 * that require caching or offline capabilities.
 */
function compileObjectStoreDefinitions() {
  /**
   * Object store definitions for IndexedDB,
   * derived from the data layer definitions.
   */
  const dd = [
    // add definition for lookup-tables,
    // as that is used for caching lookup tables
    {
      name: LOOKUP_TABLES,
      options: {
        keyPath: ["$ident", "sifra"],
      },
    },
  ];

  Array.from(DEFINITIONS.values()).forEach((def) => {
    const canAdd = (d) =>
      typeof d === "object" &&
      d.name &&
      !dd.some(({ name }) => name === d.name);

    // push unique cache & offline to “dd”
    if (canAdd(def.cache)) {
      console.log("Adding cache definition for", def.ident);
      dd.push(def.cache);
    }

    if (canAdd(def.offline)) {
      console.log("Adding offline definition for", def.ident);
      dd.push(def.offline);
    }
  });

  return dd;
}

/**
 * Generic Offline Store
 *
 * @var {IndexedDB} idb - IndexedDB instance to interact with the local store
 */
const idb = new IndexedDB(DB_NAME, DB_VERSION, compileObjectStoreDefinitions);

/**
 * Its quite unlikely that we will need to interact with IndexedDB directly
 * from the components or other parts of the app,
 */
export default idb;
